const WALLET_LIST_KEYS = [
  'subWallets',
  'wallets',
  'linkedSubWallets',
  'walletIds',
  'linkedWallets',
];
const ADDRESS_KEYS = ['walletId', 'address', 'publicKey', 'subWalletId'];
// checkin-svc PR 83 (not deployed): 409 { code: 'HAS_LINKED_SUBWALLETS', linkedSubWallets }.
// The live API before that deploy: 400 { code: 'HAS_SUB_WALLETS' } and no addresses.
const LINKED_CONFLICTS = [
  { status: 409, code: 'HAS_LINKED_SUBWALLETS' },
  { status: 400, code: 'HAS_SUB_WALLETS' },
];

const addressOf = item => {
  if (typeof item === 'string') return item.trim();
  if (!item || typeof item !== 'object') return '';
  for (const key of ADDRESS_KEYS) {
    if (typeof item[key] === 'string' && item[key].trim()) return item[key].trim();
  }
  return '';
};

const listsIn = value => {
  if (!value) return [];
  if (Array.isArray(value)) return [value];
  if (typeof value !== 'object') return [];
  return WALLET_LIST_KEYS.filter(key => Array.isArray(value[key])).map(key => value[key]);
};

// GSI2 can return the primary beside its subs. Drop the primary and anything
// that is not an address. Order is the order the payload listed them.
export const linkedSubWalletAddresses = (body, primaryWalletId = '') => {
  const pools = [
    ...listsIn(body),
    ...listsIn(body?.payload),
    ...listsIn(body?.data),
    ...listsIn(body?.error),
  ];
  const seen = new Set();
  const addresses = [];
  for (const list of pools) {
    for (const item of list) {
      if (item && typeof item === 'object' && item.isPrimary === true) continue;
      const address = addressOf(item);
      if (!address || address === primaryWalletId || seen.has(address)) continue;
      seen.add(address);
      addresses.push(address);
    }
  }
  return addresses;
};

const codesIn = body => {
  if (!body || typeof body !== 'object') return [];
  return [body.code, body.errorCode, body.error?.code, body.payload?.code].filter(
    code => typeof code === 'string'
  );
};

// A 409 HAS_LINKED_SUBWALLETS carries linkedSubWallets. A 400 HAS_SUB_WALLETS
// does not, so the caller reloads getAllWalletsByPrimaryWallet. Other 400/409
// codes (PROFILE_MISMATCH, a missing reason) are not this conflict.
export const isLinkedSubWalletConflict = error => {
  const status = error?.response?.status;
  const codes = codesIn(error?.response?.data);
  return LINKED_CONFLICTS.some(
    conflict => conflict.status === status && codes.includes(conflict.code)
  );
};

export const linkedSubWalletsFromConflict = (error, primaryWalletId = '') =>
  linkedSubWalletAddresses(error?.response?.data, primaryWalletId);

// The archive write deletes the live WALLET# row and leaves a tombstone
// (DEGEN-898): top-level archivedAt, pk ARCHIVED_WALLET#…. The admin list may
// also send archived: true or status ARCHIVED. Any of those means the wallet
// is already archived, so the Archive control stays off.
export const isArchivedKycProfile = profile => {
  if (!profile || typeof profile !== 'object') return false;
  if (profile.archived === true) return true;
  if (profile.archivedAt != null && profile.archivedAt !== '') return true;
  if (typeof profile.pk === 'string' && profile.pk.startsWith('ARCHIVED_WALLET#')) return true;
  return typeof profile.status === 'string' && profile.status.toUpperCase() === 'ARCHIVED';
};
